import { errorMessage } from "./errorMessage";

export const renderIfItemsExist = (products, template) =>
  !products || products.length === 0
    ? errorMessage(
        "Apologies, these products haven't loaded. Please try again later."
      )
    : template;
